import { useEffect, useRef, useState } from 'react'


const StringTypeInput = (props: any) => {

  const { row, column, table, getValue } = props.props;
  const [editValue, setValue] = useState(getValue() !== '' ? getValue() : null)
  const [ isDelete, setIsDelete ] = useState(false);


  useEffect(() => {
    const cellValue = getValue();
 if(cellValue!==undefined && cellValue !== null){
  setValue(cellValue);
 }
  
//  console.log("props.props.colummn", props.props.column)
 if(props.props.column.id === 'testName' && props.props.row.original.isBusinessCreated === false){
   setIsDelete(true)
    // Reset to empty string if testName is empty
 }
  }, [getValue()])


  const updateValue = (val: string) => {
    setValue(val)
  }

  const onBlur = () => {
    console.log("onBlur called with value:", editValue);
    console.log("row index:", row.index, "column id:", column.id);
    table.options.meta?.updateData(row.index, column.id, editValue);
  }

  const refInput = useRef<HTMLInputElement>(null)
  return (
    <input
      className='table-input bg-white'
      style={{ width: '100%' }}
      disabled={isDelete}
      value={editValue}
      placeholder={props.placeholder}
      ref={refInput}
      onChange={(event) => updateValue(event.target.value)}
      onBlur={() => onBlur()}
    />
  )
}

export default StringTypeInput
